import React from 'react';

const HorizontalNav = ({info,index}) => {
    function rebuildFP() {
    
        window.fullpage_api.reBuild()
      
    }
    return (

        <button className={`nav-link mb-2 ${index===1 &&"active"}`} id={`nav-${index}-tab`} data-bs-toggle="tab" data-bs-target={`#nav-${index}`} type="button" role="tab" aria-controls={`nav-${index}`} aria-selected= {` ${index===1 ?"true":"false"}`} onClick={() => rebuildFP()}>
        <img className='img-fluid' src={info?.img?.url} alt=""/>
        { info?.text}
         
         </button>
    );
};

export default HorizontalNav;